// extracted by mini-css-extract-plugin
module.exports = {"fadeReplace":"fade-replace","fadeReplaceTxIn":"200","fadeReplaceTxOut":"400"};